
export default {
  mounted() {
    console.log('blog layout mounted');
  }
};
